import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../../../AbstractElements';
import PropertyEdit from './PropertyEdit';


const EditProperty = () => {
    return (
        <Fragment>
            <Breadcrumbs mainTitle='Edit Property' parent='Property' title='Property Edit' />
            <Container fluid={true}>
                <div className='edit-profile'>
                    <Row>
                        <PropertyEdit />
                    </Row>
                </div>
            </Container>
        </Fragment>
    )
}

export default EditProperty